// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconBreadOff = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M16.845 1h2.143L8 23H5.857l.999-2H4.25v-9.171a2.8 2.8 0 01-1.634-1.273C2.131 9.751 2 8.741 2 7.804c0-1.167.465-2.107 1.224-2.803.73-.67 1.693-1.08 2.683-1.329l.027-.006.028-.006c3.87-.742 6.37-.843 9.744-.38zM6.367 5.619c3.362-.643 5.571-.774 8.392-.443L7.855 19H6.25V9.966h-1c-.54 0-.768-.188-.921-.442-.204-.34-.329-.91-.329-1.72 0-.58.21-.994.576-1.33.39-.358.994-.652 1.79-.855"
    />,
    <path d="M11.246 21h8.504v-9.171a2.8 2.8 0 001.634-1.273c.485-.805.616-1.815.616-2.752 0-1.167-.465-2.107-1.224-2.803a5 5 0 00-1.146-.775l-.895 1.79q.414.205.69.459c.365.335.575.75.575 1.33 0 .809-.125 1.38-.329 1.719-.154.254-.38.442-.921.442h-1V19h-5.505z" />
  );
export default SvgIconBreadOff;
